<template>
    <div class="catalog-content">
        <div class="row">
            <div class="col-12 product-tiles">
                <ad name="ad_above_catalog" class="mb-3"></ad>

                <div class="product-tile-list">
                    <div v-if="entries.length"
                        v-for="(entry, index) in entries"
                    >
                        <product-tile
                            :key="entry.id"
                            :is-loading="isLoading"
                            :entry="entry"
                            :power-type="powerType"
                        ></product-tile>

                        <ad
                            v-if="index == getAdSpot"
                            name="ad_catalog"
                            class="mb-4"
                        ></ad>
                    </div>
                    <div class="card" v-if="entries.length === 0">
                        <div class="card-body">
                            <span v-html="$t('cat.content.no_vehicle')"></span>
                        </div>
                    </div>
                </div>

                <ad name="ad_below_catalog" class="mb-3"></ad>
            </div>
        </div>
        <div class="row d-flex justify-content-center justify-content-md-end pr-md-0 mt-4">
            <div class="col-12 col-md-5 col-lg-4">
                <div class="row d-flex justify-content-center justify-content-md-end">
                    <div class="col-5 col-md-8 d-flex align-items-center justify-content-end">
                        {{$t('cat.content.vehicle_per_page')}}
                    </div>
                    <div class="col-4">
                        <b-form-select v-model="perPage">
                            <b-form-select-option
                                v-for="entryToShow in entriesToShow"
                                :key="entryToShow"
                                :value="entryToShow"
                            >
                                {{ entryToShow }}
                            </b-form-select-option>
                        </b-form-select>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-3 d-flex justify-content-center justify-content-md-end mt-3 mt-md-0 pl-md-0">
                <pagination
                    :current-page="currentPage"
                    :max-page="maxPage"
                    @change-page="updatePagination"
                    v-if="!isLoading"
                ></pagination>
            </div>
        </div>
    </div>
</template>

<script>
import Ad from "../atoms/Ad.vue";
import { BFormSelect, BFormSelectOption } from 'bootstrap-vue';
import HeroBox from "../molecules/HeroBox.vue";
import ProductTile from "../molecules/ProductTile.vue";
import Pagination from "../atoms/Pagination.vue";
import { EventBus } from "../../event-bus"

export default {
    name: 'CatalogContent',
    components: {
        Ad,
        Pagination,
        ProductTile,
        HeroBox,
        BFormSelect, BFormSelectOption,
    },
    data() {
        return {
            isLoading: true,
            entries: [],
            currentPage: 1,
            maxPage: 1,
            entriesToShow: [ 10, 25, 50, 100],
            perPage: 10,
            vehicleListUrl: '',
            filters: this.getFilterPresets(),
            powerType: 'PS',
            dataLoader: null,
        }
    },
    methods: {
        getFilterPresets(){
            return {
                minimum_duration: -1,
                duration_options: -1,
                mileage: -1,
                category: -1,
                brand: -1,
                model: -1,
                vehicle_condition: -1,
                power: -1,
                fuel: -1,
                gearshift: -1,
                top_feature: 0,
                price: -1,
                first_registration: -1,
                per_page: 10,
                page: 1,
                sort: 'rankingDesc',
                power_type: "PS"
            }
        },
        getProducts(){
            this.isLoading = true

            if(this.dataLoader) {
                clearTimeout(this.dataLoader);
            }

            this.dataLoader = setTimeout(() => {
                this.$axios(this.builtApiUrl)
                    .then(r => {
                        if(r.data.data) {
                            this.entries = r.data.data
                            this.currentPage = r.data.meta.current_page;
                            this.maxPage = r.data.meta.last_page;

                            EventBus.$emit('change-entry-counter', r.data.meta.total);
                        } else {
                            this.entries = [];
                            EventBus.$emit('change-entry-counter',0);
                        }

                        this.isLoading = false
                    });

                this.dataLoader = null;
            }, 500);

        },
        buildPlaceholderEntryArray(){
          do {
              this.entries.push({id: this.entries.length})
          } while ( this.entries.length <= this.perPage)
        },
        updatePagination(data){
            this.currentPage = data

            this.getProducts();
        },
        updateFilter(data){
            this.filters[data.filter] = data.value

            if(data.value != "[]") {
                this.addFilterToUrl(data)
            } else {
                this.removeFilterFromUrl(data)
            }

            this.updateFilterCounter(this.$route.query[data.filter], data.filter)
        },
        removeFilterFromUrl(data) {
            const query = Object.assign({}, this.$route.query)
            delete query[data.filter]
            this.$router.replace({ query })
        },
        addFilterToUrl(data){
            this.$router.push({ query: Object.assign({}, this.$route.query, { [data.filter] : data.value }) })
            .catch(e =>{
                return
            })
        },
        removeFilterToUrl(data){
            this.$router.push({ query: { sort: this.getSorting}})
        },
        updatePowerType(data){
            this.powerType = data.powerType
            this.$forceUpdate()
        },
        updateFilterCounter(data, name){
            if(data === ''){
                data = '-1'
            }
            EventBus.$emit('catalog-update-filter-counter', {value: data, name: name});
        },
        resetFilter(){
            setTimeout(() => {
              this.filters = this.getFilterPresets()
              this.perPage = this.filters.per_page
              this.$router.push({ query: { sort: this.getSorting}})
            }, 1000);
        }
    },
    computed: {
        getAdSpot() {
            return Math.floor(this.entries.length / 2) - 1
        },
        builtApiUrl: function (){
            const url = `/api/v1/catalog/list_vehicles?
                minimum_duration=${this.getMinimumDuration}&
                duration_options=${this.getDurationOptions}&
                mileage=${this.getMileage}&
                category=${this.getCategory}&
                brand=${this.getBrand}&
                model=${this.getModel}&
                vehicle_condition=${this.getVehicleCondition}&
                power=${this.getPower}&
                powerType=${this.getPowerType}&
                fuel=${this.getFuel}&
                gearshift=${this.getGearshift}&
                top_feature=${this.getTopFeature}&
                price=${this.getPrice}&
                per_page=${this.perPage}&
                page=${this.currentPage}&
                sort=${this.getSorting}`
            return url.replace(/\s/g, '')
        },
        getSorting: function (){
            if(this.$route.query.sort){
                this.filters.sort = this.$route.query.sort
                EventBus.$emit('update-catalog-sort-by-route', this.$route.query.sort);
            }

            return this.filters.sort
        },
        getRowsPerPage: function (){
            if(this.$route.query.limit){
                return this.$route.query.limit
            }
            return this.perPage;
        },
        getPrice: function (){
            if(this.$route.query.price){
                this.updateFilterCounter(this.$route.query.price, 'price')
                this.filters.price = this.$route.query.price
            }

            return this.filters.price
        },
        getGearshift: function (){
            if(this.$route.query.gearshift){
                this.updateFilterCounter(this.$route.query.gearshift, 'gearshift')
                this.filters.gearshift = this.$route.query.gearshift
            }

            return this.filters.gearshift
        },
        getVehicleCondition: function (){
            if(this.$route.query.vehicle_condition){
                this.updateFilterCounter(this.$route.query.vehicle_condition, 'vehicle_condition')
                this.filters.vehicle_condition = this.$route.query.vehicle_condition
            }

            return this.filters.vehicle_condition
        },
        getFuel: function (){
            if(this.$route.query.fuel){
                this.updateFilterCounter(this.$route.query.fuel, 'fuel')
                this.filters.fuel = this.$route.query.fuel
            }

            return this.filters.fuel
        },
        getCategory: function (){
            if(this.$route.query.category){
                this.updateFilterCounter(this.$route.query.category, 'category')
                this.filters.category = this.$route.query.category
            }

            return this.filters.category
        },
        getTopFeature: function (){
            if(this.$route.query.top_feature){
                this.updateFilterCounter('top_feature', 'top_feature')
                this.filters.top_feature = this.$route.query.top_feature
            }

            return this.filters.top_feature
        },
        getPower: function (){
            if(this.$route.query.power){
                this.updateFilterCounter(this.$route.query.power, 'power')
                this.filters.power = this.$route.query.power
            }

            return this.filters.power
        },
        getPowerType: function (){
            if(this.$route.query.power_type){
                this.updateFilterCounter(this.$route.query.power_type, 'power_type')
                this.filters.powerType = this.$route.query.power_type
            }

            return this.filters.powerType
        },
        getMinimumDuration: function (){
            if(this.$route.query.minimum_duration){
                this.updateFilterCounter(this.$route.query.minimum_duration, 'minimum_duration')
                this.filters.minimum_duration = this.$route.query.minimum_duration
            }

            return this.filters.minimum_duration
        },
        getMileage: function (){
            if(this.$route.query.mileage){
                this.updateFilterCounter(this.$route.query.mileage, 'mileage')
                this.filters.mileage = this.$route.query.mileage
            }

            return this.filters.mileage
        },
        getDurationOptions: function (){
            if(this.$route.query.duration_options){
                this.updateFilterCounter(this.$route.query.duration_options, 'duration_options')
                this.filters.duration_options = this.$route.query.duration_options
            }

            return this.filters.duration_options
        },
        getBrand: function (){
            if(this.$route.query.brand){
                this.updateFilterCounter(this.$route.query.brand, 'brand')
                this.filters.brand = this.$route.query.brand
            }

            return this.filters.brand
        },
        getModel: function (){
            if(this.$route.query.model){
                this.updateFilterCounter(this.$route.query.model, 'model')
                this.filters.model = this.$route.query.model
            }

            return this.filters.model
        }
    },
    watch: {
        perPage() {
            this.currentPage = 1;
            this.getProducts();
            let data = { filter: "limit", value: this.perPage }
            const filters = this.getFilterPresets()
            if (filters.per_page == this.perPage) {
                data.value = ""
                this.updateFilter(data)
                return;
            }
            this.updateFilter(data)
        },

        filters: {
            handler(filter) {
                this.getProducts()
            },
            deep: true,
        }
    },
    mounted() {
        if(this.$route.query.page) {
            this.currentPage = parseInt(this.$route.query.page);
        }

        this.perPage = this.getRowsPerPage;
        this.buildPlaceholderEntryArray()
        this.getProducts()

        EventBus.$on('update-catalog-filter', this.updateFilter);
        EventBus.$on('update-catalog-power-type', this.updatePowerType);
        EventBus.$on('catalog-filters-reset', this.resetFilter);
    }
}
</script>
